<template lang="pug">
  label.n-text-field
    span.d-block.mb-1(v-if="label")
      h5.black--text {{ label }} 
    v-text-field( 
      v-on="$listeners"
      :value="selectItem"
      dense
      outlined
      height="20" 
      :readonly="readonly"
      hide-details="auto"
      :placeholder="placeholder"
      style="border-radius:10px; min-height:20px;" 
    )
      template(#append)
        v-icon(
          small
          color="var(--bg-main-color-2-v2)"
        ) mdi-arrow-down-drop-circle
      
      template(
        v-for="key in templateKeys"
        v-slot:[key]="props" 
      )
        slot(
          :name="key"
          v-bind:item="props.item"
          v-bind:headers="props.headers"
          v-bind:value="props.value"
        )
</template>
<script>
export default {
  props: {
    value:{ 
      type: [String,Object, Number],
      default: () => {} 
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      deafult: false
    }
  },
  data: () => ({
    selectItem:null
  }),
  computed: {
    templateKeys () {
      return Object.keys(this.$scopedSlots)
    },
  },
  watch: {
    value (val) {
      this.selectItem = val
    },
    selectItem (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.selectItem = this.value
  },
}
</script>
<style>
label{
  display: inline-block;
  width: 100%;
}    
.v-input__slot {
  min-height: 30px !important;
}
</style> 